import React from 'react';
import * as classes from './FooterMenu.module.scss';
import { useId } from '../../hooks/useId';
import { FooterLink, IFooterLinkProps } from './FooterLink';


export interface IFooterMenuProps {
    title: string;
    links: IFooterLinkProps[];
}

export const FooterMenu: React.FunctionComponent<IFooterMenuProps> = props => {
    const headingId = useId();
    return (
        <div role="group" aria-labelledby={headingId} className={classes.wrapper}>
            <div className={classes.heading} id={headingId}>{props.title}</div>
            <ul className={classes.list}>
                {props.links.map((linkProps, i) => {
                    return (
                        <li
                            key={i}
                            className={classes.link}>
                            <FooterLink {...linkProps} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
